  
<ss-sidenav *ngIf="refreshTokenExistsSubject | async;else auth">
  <router-outlet></router-outlet>
</ss-sidenav>
<ng-template #auth>
  <router-outlet></router-outlet>
</ng-template>
<ss-core-root-loader-outlet></ss-core-root-loader-outlet>
<ss-core-subtle-loader-outlet></ss-core-subtle-loader-outlet>
